import { Router } from '@angular/router'
import { Wishlist } from '../../../../graphql'
import { activeWishlistKey } from '../../../constant'
import { Amplitude } from '../../../injectable'

export interface SerializedWishlist {
    wishlistId: string
}

export function fetchActiveWishlist(): SerializedWishlist {
    const serializedWishlist: string = sessionStorage.getItem(activeWishlistKey)
    return serializedWishlist ? JSON.parse(serializedWishlist) : null;
}

export function storeAsActiveWishlist(wishlist: Wishlist, amplitude: Amplitude, router: Router): void {
    if (!wishlist) {
        console.error('Cannot store empty wishlist as active wishlist')
        return
    }
    sessionStorage.setItem(activeWishlistKey, JSON.stringify({
        wishlistId: wishlist.wishlistId,
        name: wishlist.name,
    }))

    if (router) {
        router.navigate(["/"])
    }
}

